/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React  from 'react';
import { connect } from 'react-redux';
import { object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { getBrand } from '../../state/ducks/Common/Common-Selectors';
import AccountLeftMenu from '../../common/Desktop/AccountLeftMenu';
import WishlistComponent from '../../../../components/GraphqlComponents/WishlistPage/Wishlist';

const styles = () => ({
    CustomerWrapperPLA: {
        '&.PLA': {
            padding: '0 15px',
            maxWidth: '1270px',
            margin: '55px auto',
            flexDirection: 'column',
        },
    },
});
const Wishlist = ({
    userProfile, brand, classes,
}) => (
    <div className={`container PLA ${classes.CustomerWrapperPLA}`}>
        <AccountLeftMenu brand={brand} userProfile={userProfile} />
        <WishlistComponent showLabel={false} />
    </div>
);
Wishlist.propTypes = {
    classes: object.isRequired,
    userProfile: object.isRequired,
    brand: object.isRequired,
};

const mapDispatchToProps = (state) => ({
    brand: getBrand(state),
});

export default connect(mapDispatchToProps)(withStyles(styles)(Wishlist));
